import {
  CopyOutlined,
  CreditCardOutlined,
  EnvironmentOutlined,
  GiftOutlined,
  HomeOutlined,
  LockOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  ShoppingCartOutlined,
  TruckOutlined,
} from "@ant-design/icons";
import { useMemo } from "react";
import { Alert, Button, Card, Col, ConfigProvider, Divider, Form, Image, Input, message, Modal, Radio, Row, Select, Space, Steps, Tag, Typography } from "antd";
import axios from "axios";
import { list } from "cart-localstorage";
import { concat } from "lodash";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import { toast } from "react-toastify";
import { Price } from "../../components/__simple/_price";
import config from "../../configuration/config";
import { useUserCart } from "../../User/hooks/useUserCart";
import ConfirmContext from "../../utils/confirmContext";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import BranchesInfo from "../cart/component/BranchInfo";
import CheckoutProgressModal from "./components/checkout_progress_modal.jsx";
import Breadcrumb from "../../components/__simple/breadcrumb";

const { Text } = Typography;

// ألوان الموقع المحدثة مع تدرجات إضافية
const colors = {
  primary: "#00b362",
  primaryLight: "#00b362",
  primaryDark: "#00b362",
  primaryGradient: "#00b362",

  // ألوان تويوتا
  toyota: "#fafafaff",
  toyotaDark: "#0f0f0f",
  bgToyota: "#f81414ff",
  textToyota: "#ffffffff",
  toyotaGradient: "linear-gradient(135deg, #d1d1d1 0%, #0f0f0f 100%)",

  // ألوان لكزس
  lexus: "#0f0f0f",
  lexusLight: "#dfdfdf",
  bgLexus: "#1a1a1a",
  textLexus: "#ffffff",
  lexusGradient: "linear-gradient(135deg, #0f0f0f 0%, #dfdfdf 100%)",

  // ألوان عامة
  white: "#ffffff",
  grayLighter: "#f8f8f8",
  grayLight: "#e6e6e6",
  gray: "#979595",
  grayDark: "#707070",
  black: "#000000",
  success: "#00b362",
  warning: "#ffc107",
  danger: "#d62828",
  info: "#2c80ff",
  accent: "#ff6b35",
};

// نظام أحجام الخطوط
const textSizes = {
  10: "1rem",
  11: "1.1rem",
  12: "1.2rem",
  13: "1.3rem",
  14: "1.4rem",
  15: "1.5rem",
  16: "1.6rem",
  17: "1.7rem",
  18: "1.8rem",
  20: "2.1rem",
  24: "2.5rem",
  30: "3.1rem",
  40: "4.1rem",
  50: "5.1rem",
};

// خيارات الشحن
const shippingOptions = [
  {
    id: 1,
    name: "توصيل عادي",
    price: 25.0,
    duration: "3-5 أيام عمل",
    description: "توصيل إلى العنوان المحدد",
    icon: "🚚",
  },
  {
    id: 2,
    name: "توصيل سريع",
    price: 45.0,
    duration: "1-2 أيام عمل",
    description: "توصيل سريع مع التتبع",
    icon: "⚡",
    popular: true,
  },
  {
    id: 3,
    name: "توصيل فوري",
    price: 75.0,
    duration: "نفس اليوم",
    description: "توصيل خلال 4 ساعات",
    icon: "🚀",
  },
];

const PremiumCheckoutPage = () => {
  const { t: trans, i18n } = useTranslation(["info", "extra", "cartFile", "new"]);
  let lang = i18n.language || "ar";
  const [form] = Form.useForm();
  const location = useLocation();
  const { removePulkcartItems } = useUserCart();
  const thisConfirmContext = useContext(ConfirmContext);
  const history = useHistory();
  const deliveryType = Form.useWatch("deliveryType", form); // ✅ يراقب التغييرات مباشرة
  const paymentType = Form.useWatch("paymentType", form); // ✅ يراقب التغييرات مباشرة
  const [formReady, setFormReady] = useState(false);
  const [items, setItems] = useState([]); // جلب العناصر من التخزين المحلي
  const [showFinalPopupMessage, setShowFinalPopupMessage] = useState();
  const [sadadInfo, setSadadInfo] = useState(null);
  const [dataFinalPopup, setDataFinalPopup] = useState({});
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [isLoadingSendOrder, setLoadingSendOrder] = useState(false);
  const [partErrors, setPartErrors] = useState([]); // ids المنتجات اللي كميتها غير متوفرة
  const [stockList, setStockList] = useState([]); // المخزون القادم من السيرفر (اختياري)
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [personalDataRequest, setPersonalDataRequest] = useState({
    arFirstName: "",
    arMiddleName: "",
    arLastName: "",
    enFirstName: "",
    enMiddleName: "",
    enLastName: "",
    genderID: "",
    address: "",
    cityID: "",
    countryID: "",
    logo: "",
  });
  const handelSetPersonalData = useCallback(async () => {
    // You can await here
    const isLogin = getData("isAuthenticated");
    if (isLogin) {
      const userData = JSON.parse(getData(User_Data_Key, true));
      // console.log("userData>>>>>>>>>>>>>>>>:", userData);
      if (userData) {
        setPersonalDataRequest(userData);
        var name =
          lang == "ar"
            ? (userData?.arFirstName ?? "") + " " + (userData?.arMiddleName ?? "") + " " + (userData?.arLastName ?? "")
            : (userData?.enFirstName ?? "") + " " + (userData?.enMiddleName ?? "") + " " + (userData?.enLastName ?? "");

        userData["name"] = name;

        const val = {};
        val.name = name;

        // const match = userData?.phone.match(/^(\+\d{1,4})(\d+)$/);

        const mainNumber = userData?.phone?.slice(-9); // Last 9 digits, e.g., 530005261
        // Get everything before the last 9 digits as the country code
        const countryCode = userData?.phone?.slice(0, -9);
        val.phoneNumberCode = countryCode.replace("+", "");
        val.phoneNumberOnly = mainNumber;
        val.phoneNumber = userData?.phone ? userData?.phone : "";
        // val.accountType = (userData?.custGroupID && allowCustGroups.includes(userData?.custGroupID)) ? userData?.custGroupID : allowCustGroups[0];
        val.isClientAccount = val.accountType === "G4" ? true : false;
        val.identity = userData?.identity ? userData?.identity : "";
        val.commercialIdentity = userData?.tradeNo ? userData?.tradeNo : "";
        val.address = userData?.address ?? "";
        val.City = userData?.cityID ?? "";
        // handelSetRequestForm(val);

        form.setFieldValue("name", name);
        form.setFieldValue("phoneNumber", val.phoneNumberOnly);
        form.setFieldValue("phoneNumberCode", val.phoneNumberCode);
      }
    } else {
      history.push({
        pathname: `/parts/cart`,
        search: "",
      });
      thisConfirmContext.onShowRegistrationPup(true);
    }

    // ...
  }, []);

  const rules_schema_1 = {
    name: [
      { required: true, message: "الاسم مطلوب" }, // ✅ أضف رسالة خطأ
    ],
    phoneNumber: [
      { required: true, message: "رقم الجوال مطلوب" },
      { min: 9, max: 9, message: "رقم الجوال يجب أن يكون 9 أرقام على الأقل" }, // ✅ صحح من 12 إلى 10
    ],
    deliveryType: [{ required: true, message: "طريقة الاستلام مطلوبة" }],

    develviryBranch: [
      { required: true, message: " اختيار الفرع مطلوبة" },
      { type: "string", message: " اختيار الفرع مطلوبة" },
    ],

    develviryCity: [
      { required: true, message: "اختيار المدينة مطلوبة" },
      { type: "string", message: "اختيار المدينة مطلوبة" },
    ],
    address: [
      { required: true, message: "تفاصيل العنوان  مطلوبة" },
      { type: "string", message: "تفاصيل العنوان  مطلوبة" },
    ],
  };

  const rules_schema_2 = {
    paymentType: [
      { required: true, message: "اختيار طريقة الدفع مطلوبة" },
      { min: 1, message: "اختيار طريقة الدفع مطلوبة" },
    ],
  };

  const rules_schema_3 = {};
  const stepRules = [rules_schema_1, rules_schema_2, rules_schema_3];
  const [stepNum, setStepNum] = useState(0);

  const handleNext = async () => {
    try {
      await form?.validateFields(Object.keys(stepRules[stepNum]));

      // ✅ قبل الدخول لخطوة التأكيد (step 2) نفحص المخزون
      // عدّل الشرط حسب منطق خطواتك (هنا: خطوة 2 هي confirm)
      // if (stepNum === 1) {
      //   const errors = await handleCheckpartsCount(items);
      //   if (errors.length > 0) return; // ⛔ لا ينتقل
      // }
      console.log("stepNum:", stepNum);

      const deliveryTypeValue = form.getFieldValue("deliveryType");
      const selectedSiteId = form.getFieldValue("develviryBranch"); // هذا SiteID عندك

      const res = await handleCheckpartsCountSingleSite(items, deliveryTypeValue === 1 ? selectedSiteId : null);

      if (!res.ok) return; // ⛔ امنع الانتقال

      if (stepNum < stepRules.length - 1) {
        setStepNum(stepNum + 1);
      } else if (stepNum === stepRules.length - 1) {
        handleSubmit();
      }
    } catch {}
  };

  const handlePrev = () => {
    if (stepNum > 0) setStepNum(stepNum - 1);
  };

  const [selectedShipping, setSelectedShipping] = useState(shippingOptions[1]);
  const [selectedPayment, setSelectedPayment] = useState("card");

  const [error, setError] = useState({});
  const [resOrderID, setResOrderID] = useState(null);
  const [ValueBranch, setValueBranch] = useState("");
  function handelValueBranch(option) {
    console.log("handelValueBranch:", option);
    setValueBranch(option.value);
  }
  const [ValueCitie, setValueCitie] = useState("");
  function handelValueCitie(option) {
    console.log("handelValueCitie:", option);
    setValueCitie(option.value);
  }

  useEffect(() => {
    const paymentStatus = new URL(window.location.href).searchParams.get("paymentStatus");
    const orderId = new URL(window.location.href).searchParams.get("orderId") ?? new URL(window.location.href).searchParams.get("Id");

    const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
    const paymentTypeCallback = new URL(window.location.href).searchParams.get("PaymentType");
    if (paymentMethodCallback != null && paymentTypeCallback != null) {
      SendAllPaymentStatus_Service_Spare(orderId, paymentMethodCallback, paymentStatus);
    } else {
    }
  }, []);
  function getCartList() {
    // الأنواع التي تريد فلترتها
    const types = ["part"];
    const lowerTypes = types.map((t) => t.toLowerCase());

    // جلب كل العناصر من السلة
    const items = list() || [];

    // فلترة العناصر حسب النوع
    // إذا أردت تحويل أو إضافة خصائص افتراضية
    const filteredItems = items
      .filter((item) => lowerTypes.includes(item.Type?.toLowerCase()))
      .map((item) => ({
        ...item,
        name: lang == "ar" ? item.name : item.nameEn,
        partNumber: item.productNo || "LEX-90919-01159",
        originalPrice: item.originalPrice || item.price / 1.15,
        image: item.image || "https://appw.hassanjameelapp.com/assets/images/parts/PARTS_TOYOTA-AR-no-img.png",
        brandName: item.brandName || item.brand || "تويوتا",
        brandId: item.brand,
        warranty: item.warranty || "غير محدد",
        stock: item.stock ?? 10,
        quantity: item.quantity || 1,
        compatibility: ["لكزس ES 2020-2023", "لكزس IS 2021-2023"],
        isGenuine: true,
        isPremium: true,
        rating: 4.9,
        reviews: 89,
        features: ["إيريديوم متقدم", "استهلاك وقود أقل", "أداء محسن"],
      }));

    // const filteredItems = orderItems
    setItems(filteredItems);

    return filteredItems;
  }

  useEffect(() => {
    async function fetchData() {
      await handelSetPersonalData();

      const cart = getCartList();
      handleFetchCountries();
      GetBranch();
      // ✅ فحص المخزون أول ما تدخل التشيك آوت
      await handleCheckpartsCountSingleSite(cart);
    }
    fetchData();
  }, []);
  // حسابات الطلب
  const subtotal = items.reduce((total, item) => total + item.originalPrice * item.quantity, 0);
  const discount = 0;
  const shippingCost = 0;
  const tax = subtotal * 0.15;
  const total = subtotal + shippingCost + tax - discount;
  const totalItems = items.length;
  const savedAmount = items.reduce((total, item) => total + (item.originalPrice - item.price) * item.quantity, 0);
  const [MessageError, setMessageError] = useState(null);

  const [platformTypes, setPlatformTypes] = useState([]);

  useEffect(() => {
    // تحميل الملف من مجلد public
    const loadManifest = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Filter and map to extract keys with isActive = true
        var sparePartsPlatformsTypes = data.sparePartsPlatformsTypes || [];
        const activeKeys = sparePartsPlatformsTypes.filter((platform) => platform.isActive).map((platform) => platform.key);

        console.log("Active keys:", activeKeys);

        setPlatformTypes(activeKeys);
      } catch (error) {
        console.error("Error loading manifest.json:", error);
      }
    };

    loadManifest();
  }, []);

  const getpartsCount = async () => {
    const cartItems = getCartList(); // أو استخدم items الحالية لو متأكد أنها أحدث
    if (!cartItems.length) return [];

    const productListIds = cartItems.map((a) => a.ProductID).join(",");

    const Body = { productListIds };

    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/site_FeatchPartQty`, Body);
      const data = response.data || [];
      setStockList(data);
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const handleCheckpartsCount = async (itemsToCheck = items) => {
    const listError = [];

    // أنت أصلاً في checkout → غالبًا لازم يكون مسجل دخول
    const isLogin = getData("isAuthenticated");
    if (!isLogin) {
      thisConfirmContext.onShowRegistrationPup(true);
      return [];
    }

    if (!itemsToCheck || itemsToCheck.length === 0) return [];

    const stock = await getpartsCount();

    itemsToCheck.forEach((item) => {
      const totalQty = stock.filter((s) => s.ProductID === item.ProductID).reduce((sum, s) => sum + Number(s.TotalQty), 0);

      if (totalQty < item.quantity) {
        listError.push(item.id);
      }
    });

    setPartErrors(listError);

    if (listError.length > 0) {
      message.error({
        content: (
          <div
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            الكمية المطلوبة غير متوفرة في جميع الفروع
          </div>
        ),
        duration: 3,
      });
    }

    return listError;
  };
  // الحصول على ألوان البراند
  const getBrandColors = (brandId) => {
    if (brandId === "1") {
      return {
        background: colors.bgLexus,
        text: colors.textLexus,
        border: colors.lexus,
        gradient: colors.lexusGradient,
      };
    } else {
      return {
        background: colors.bgToyota,
        text: colors.textToyota,
        border: colors.toyota,
        gradient: colors.toyotaGradient,
      };
    }
  };
  //دالة تجهيز خريطة المخزون حسب الفرع
  const buildStockMapBySite = (stockRows = []) => {
    // Map<SiteID, Map<ProductID, TotalQty>>
    const bySite = new Map();

    for (const row of stockRows) {
      const siteId = String(row.SiteID);
      const productId = String(row.ProductID);
      const qty = Number(row.TotalQty ?? 0);

      if (!bySite.has(siteId)) bySite.set(siteId, new Map());
      bySite.get(siteId).set(productId, qty);
    }

    return bySite;
  };
  const [fulfillmentSiteId, setFulfillmentSiteId] = useState(null);
  //دالة التحقق “فرع واحد يغطي كل السلة”
  const handleCheckpartsCountSingleSite = async (itemsToCheck = items, forcedSiteId = null) => {
    if (!itemsToCheck || itemsToCheck.length === 0) {
      setPartErrors([]);
      setFulfillmentSiteId(null);
      return { ok: true, errors: [], siteId: null };
    }

    const stock = await getpartsCount(); // rows include SiteID, SitesDescriptionAr, ProductID, TotalQty
    const bySite = buildStockMapBySite(stock);

    const canSiteFulfill = (siteId) => {
      const productMap = bySite.get(String(siteId)) || new Map();
      return itemsToCheck.every((item) => {
        const pid = String(item.ProductID);
        const required = Number(item.quantity || 0);
        const available = Number(productMap.get(pid) ?? 0);
        return available >= required;
      });
    };

    // ✅ فرع محدد
    if (forcedSiteId) {
      const ok = canSiteFulfill(forcedSiteId);

      if (ok) {
        setFulfillmentSiteId(String(forcedSiteId));
        setPartErrors([]);
        return { ok: true, errors: [], siteId: String(forcedSiteId) };
      }

      const siteIdStr = String(forcedSiteId);
      const productMap = bySite.get(siteIdStr) || new Map();

      // اسم الفرع من الـ stock (اختياري)
      const siteName = stock.find((r) => String(r.SiteID) === siteIdStr)?.[lang === "ar" ? "SitesDescriptionAr" : "SitesDescriptionEn"] || siteIdStr;

      const detailedErrors = itemsToCheck
        .map((item) => {
          const pid = String(item.ProductID);
          const required = Number(item.quantity || 0);
          const available = Number(productMap.get(pid) ?? 0);

          if (available >= required) return null;

          return {
            id: item.id,
            productId: pid,
            partNumber: item.partNumber || item.productNo || pid,
            required,
            available,
            siteId: siteIdStr,
            siteName,
          };
        })
        .filter(Boolean);

      setFulfillmentSiteId(null);
      setPartErrors(detailedErrors);

      message.error({
        content: (
          <div
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            الكمية غير متوفرة بالكامل في الفرع المختار
          </div>
        ),
        duration: 3,
      });
      return { ok: false, errors: detailedErrors, siteId: null };
    }

    // ✅ بدون فرع: ابحث عن فرع يغطي الكل
    const candidateSites = Array.from(bySite.keys());
    const feasible = candidateSites.filter(canSiteFulfill);

    if (feasible.length > 0) {
      const chosen = feasible[0];
      setFulfillmentSiteId(chosen);
      setPartErrors([]);
      return { ok: true, errors: [], siteId: chosen };
    }

    // ❌ لا يوجد فرع واحد يغطي كل السلة
    // (تفصيلي UX ممتاز) اختر “أفضل فرع” يغطي أكبر عدد من المنتجات حتى نحسب المتوفر/الناقص منه
    const scoreSite = (siteId) => {
      const productMap = bySite.get(String(siteId)) || new Map();
      let okCount = 0;
      for (const item of itemsToCheck) {
        const pid = String(item.ProductID);
        const required = Number(item.quantity || 0);
        const available = Number(productMap.get(pid) ?? 0);
        if (available >= required) okCount++;
      }
      return okCount;
    };

    let bestSiteId = candidateSites[0] || null;
    for (const s of candidateSites) {
      if (scoreSite(s) > scoreSite(bestSiteId)) bestSiteId = s;
    }

    const bestMap = bestSiteId ? bySite.get(String(bestSiteId)) || new Map() : new Map();
    const bestSiteName = bestSiteId ? stock.find((r) => String(r.SiteID) === String(bestSiteId))?.[lang === "ar" ? "SitesDescriptionAr" : "SitesDescriptionEn"] || bestSiteId : null;

    const detailedErrors = itemsToCheck
      .map((item) => {
        const pid = String(item.ProductID);
        const required = Number(item.quantity || 0);
        const available = Number(bestMap.get(pid) ?? 0);

        if (available >= required) return null;

        return {
          id: item.id,
          productId: pid,
          partNumber: item.partNumber || item.productNo || pid,
          required,
          available,
          siteId: bestSiteId,
          siteName: bestSiteName,
        };
      })
      .filter(Boolean);

    setFulfillmentSiteId(null);
    setPartErrors(detailedErrors);

    message.error({
      content: (
        <div
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            textAlign: "center",
          }}>
          لا يوجد فرع واحد يحتوي كل المنتجات بالكميات المطلوبة
        </div>
      ),
      duration: 3,
    });
    return { ok: false, errors: detailedErrors, siteId: null };
  };
  // مكون نصي مخصص
  const CustomText = ({ children, size = 14, color = "black", style = {}, ...props }) => (
    <Text
      style={{
        fontSize: textSizes[size] || size,
        color: colors[color] || color,
        lineHeight: 1.5,
        ...style,
      }}
      {...props}>
      {children}
    </Text>
  );
  const [cities, setCities] = useState([]);
  // to fetch all SAU countries
  const handleFetchCountries = async () => {
    let countries = [];
    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/site_ShippingCities`, {});
      if (response.status == 200) {
        countries = response.data.map((item) => {
          return { value: item.ID, label: item[`${trans("model:description")}`] };
        });
      }
    } catch (error) {
      //console.log('error in fetching the countries of SAU', error);
    }
    setCities(countries);
  };
  const [Branches, setBranches] = useState([]);
  const [branchesDetails, setBranchesDetails] = useState([]);
  async function GetBranch() {
    const Body = {};
    axios
      .request({
        url: `${config.controllURL}${lang}/api/Pages/site_FetchEpartsBranches`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        const result = response.data;
        setBranches(result);
        const formatResult = result.map((item) => {
          return {
            title: concat(item[`${trans("model:description")}`], item.Address ? concat("-", item.Address) : ""),
            details: item.WorkingHoursFormat,
            lat: item.Latitude,
            long: item.Longitude,
          };
        });
        setBranchesDetails(formatResult);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }

  const OrderSummary2 = () => (
    <Card
      className="premium-summary"
      style={{
        borderRadius: 20,
        border: "none",
        background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.grayLighter} 100%)`,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        position: "sticky",
        top: 20,
        overflow: "hidden",
      }}>
      {/* خلفية زخرفية */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 120,
          height: 120,
          background: colors.primaryGradient,
          borderRadius: "0 0 0 100%",
          opacity: 0.1,
        }}></div>

      <div style={{ position: "relative", zIndex: 1 }}>
        {/* شريط العنوان */}
        <div
          style={{
            padding: "16px 24px",
            color: colors.white,
            background: colors.grayLighter,
            borderRadius: 12,
          }}>
          <Space>
            <CreditCardOutlined style={{ fontSize: textSizes[18], width: "3rem" }} />
            <CustomText size={18} style={{ fontWeight: "600" }}>
              {trans("new:order_details")}
            </CustomText>
            <CustomText size={16} color="gray">
              {totalItems} {trans("cartFile:productInCart")}
            </CustomText>
          </Space>
        </div>

        <Divider style={{ margin: "16px 0" }} />

        {/* التفاصيل المالية */}
        <Space direction="vertical" style={{ width: "100%" }} size="small">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText size={16} color="grayDark">
              {" "}
              {trans("cartFile:subtotal")}
            </CustomText>
            <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
              {<Price price={subtotal.toFixed(2)} />}
            </CustomText>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText size={16} color="grayDark">
              {trans("new:tax_15")}
            </CustomText>
            <CustomText size={16} color="black">
              {<Price price={tax.toFixed(2)} />}{" "}
            </CustomText>
          </div>

          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <CustomText size={16} color="grayDark">تكاليف الشحن</CustomText>
                        <CustomText size={16} color="black">{<Price price={shippingCost.toFixed(2)} />}</CustomText>
                    </div> */}

          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', justifyItems: 'center' }}>
                        <CustomText size={16} color="success" style={{ fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                            <GiftOutlined style={{ marginLeft: 4, width: "3rem" }} />
                            التوفير
                        </CustomText>
                        <CustomText size={16} color="success" style={{ fontWeight: '600', display: 'flex', }}>-{<Price price={discount.toFixed(2)} />}</CustomText>
                    </div> */}

          <Divider style={{ margin: "12px 0" }} />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
              {trans("new:total")}
            </CustomText>
            <CustomText size={18} color="primary" style={{ fontWeight: "700" }}>
              {<Price price={total.toFixed(2)} />}
            </CustomText>
          </div>
        </Space>

        {/* معلومات الشحن */}
        <Divider style={{ margin: "20px 0" }} />
        {/* <div style={{ background: colors.grayLighter, borderRadius: 12, padding: 16 }}>
                    <CustomText size={16} color="black" style={{ fontWeight: '600', display: 'block', marginBottom: 8 }}>
                        🚚 {selectedShipping.name}
                    </CustomText>
                    <CustomText size={11} color="gray">
                        {selectedShipping.duration} • {selectedShipping.description}
                    </CustomText>
                </div> */}

        {/* ميزات إضافية */}
        <div
          style={{
            background: colors.grayLighter,
            borderRadius: 12,
            padding: 16,
            marginTop: 16,
            textAlign: "center",
          }}>
          <Space direction="vertical" size="small" style={{ width: "100%" }}>
            <SafetyCertificateOutlined style={{ fill: colors.primary, fontSize: textSizes[20], color: colors.primary, width: "4rem" }} />
            <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
              {trans("cartFile:securePurchase")}
            </CustomText>
            <CustomText size={11} color="gray">
              {trans("cartFile:warrantyAndSupport")}
            </CustomText>
          </Space>
        </div>
      </div>

      {partErrors.length > 0 && (
        <Alert
          type="error"
          showIcon
          message="لا يمكن إكمال الطلب"
          description="بعض المنتجات الكمية المطلوبة لها غير متوفرة. رجاءً عدّل الكميات من السلة."
          style={{
            marginTop: 16,
            background: colors.grayLighter,
            border: "none",
            borderRadius: 8,
          }}
        />
      )}
    </Card>
  );
  const partErrorsMap = useMemo(() => {
    const map = new Map();
    (partErrors || []).forEach((e) => map.set(e.id, e));
    return map;
  }, [partErrors]);
  const OrderSummary = () => (
    <Card
      className="premium-summary"
      style={{
        borderRadius: 20,
        border: "none",
        background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.grayLighter} 100%)`,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        position: "sticky",
        top: 20,
        overflow: "hidden",
      }}>
      {/* خلفية زخرفية */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 120,
          height: 120,
          background: colors.primaryGradient,
          borderRadius: "0 0 0 100%",
          opacity: 0.1,
        }}></div>

      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div
            style={{
              background: colors.primaryGradient,
              width: 60,
              height: 60,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
              boxShadow: "0 4px 12px rgba(0, 179, 98, 0.3)",
            }}>
            <ShoppingCartOutlined style={{ fontSize: textSizes[24], color: colors.white, width: "3rem" }} />
          </div>
          <CustomText size={20} color="black" style={{ fontWeight: "600", display: "block", marginBottom: 4 }}>
            {trans("new:order_details")}
          </CustomText>
          <CustomText size={16} color="gray">
            {totalItems} {trans("cartFile:productInCart")}
          </CustomText>
        </div>

        {/* المنتجات */}
        <Space direction="vertical" style={{ width: "100%" }} size="small">
          {items.map((item, index) => {
            const brandColors = getBrandColors(item.brand);

            const err = partErrorsMap.get(item.id);
            return (
              <div key={item.id}>
                {/* صف المنتج */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "12px 0",
                    borderBottom: `1px solid ${colors.grayLight}`,
                  }}>
                  <div style={{ position: "relative" }}>
                    <Image
                      width={60}
                      height={60}
                      src={item.image}
                      style={{
                        borderRadius: 12,
                        objectFit: "cover",
                        border: `2px solid ${colors.grayLight}`,
                        boxShadow: "0 4px 5px rgba(0, 0, 0, 0.1)",
                      }}
                      preview={false}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: -6,
                        right: -6,
                        background: brandColors.background,
                        color: brandColors.text,
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: textSizes[10],
                        fontWeight: "bold",
                      }}>
                      {item.quantity}
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <CustomText size={16} color="black" style={{ fontWeight: "500", lineHeight: 1.3 }}>
                      {item.name}
                    </CustomText>

                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
                      {/* <Tag
                        style={{
                          background: brandColors.background,
                          color: brandColors.text,
                          border: `1px solid ${brandColors.border}`,
                          borderRadius: 6,
                          fontSize: textSizes[10],
                          fontWeight: "600",
                          margin: 0,
                          padding: "1px 6px",
                        }}>
                        {item.brandName}
                      </Tag> */}

                      <CustomText size={16} color="black" style={{ fontWeight: "500", lineHeight: 1.3 }}>
                        {trans("cartFile:partNumber")} : {item.partNumber}
                      </CustomText>
                    </div>
                  </div>

                  <CustomText size={16} color="primary" style={{ fontWeight: "600" }}>
                    <Price price={(item.price * item.quantity).toFixed(2)} />
                  </CustomText>
                </div>

                {/* ✅ رسالة الخطأ تحت المنتج */}

                {err && (
                  <div
                    style={{
                      marginTop: 10,
                      padding: "8px 12px",
                      background: "#fff1f0",
                      border: "1px solid #ffa39e",
                      borderRadius: 8,
                      color: "#cf1322",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}>
                    ⚠ المنتج رقم: <b className="text-16 text-gray">{err.partNumber}</b> — المطلوب: {err.required}، المتوفر: {err.available}
                    {err.siteName ? ` (الفرع: ${err.siteName})` : ""}
                  </div>
                )}

                {/* ✅ مسافة بسيطة بين العناصر (اختياري) */}
                {index < items.length - 1 && <div style={{ height: 8 }} />}
              </div>
            );
          })}
        </Space>

        <Divider style={{ margin: "16px 0" }} />

        {/* التفاصيل المالية */}
        <Space direction="vertical" style={{ width: "100%" }} size="small">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText size={16} color="grayDark">
              {" "}
              {trans("cartFile:subtotal")}
            </CustomText>
            <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
              {<Price price={subtotal.toFixed(2)} />}
            </CustomText>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText size={16} color="grayDark">
              {trans("new:tax_15")}{" "}
            </CustomText>
            <CustomText size={16} color="black">
              {<Price price={tax.toFixed(2)} />}{" "}
            </CustomText>
          </div>

          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <CustomText size={16} color="grayDark">تكاليف الشحن</CustomText>
                        <CustomText size={16} color="black">{<Price price={shippingCost.toFixed(2)} />}</CustomText>
                    </div> */}

          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', justifyItems: 'center' }}>
                        <CustomText size={16} color="success" style={{ fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                            <GiftOutlined style={{ marginLeft: 4, width: "3rem" }} />
                            التوفير
                        </CustomText>
                        <CustomText size={16} color="success" style={{ fontWeight: '600', display: 'flex', }}>-{<Price price={discount.toFixed(2)} />}</CustomText>
                    </div> */}

          <Divider style={{ margin: "12px 0" }} />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
              {trans("new:total")}
            </CustomText>
            <CustomText size={18} color="primary" style={{ fontWeight: "700" }}>
              {<Price price={total.toFixed(2)} />}
            </CustomText>
          </div>
        </Space>

        {savedAmount > 0 && (
          <div
            style={{
              background: colors.primaryGradient,
              border: `1px solid ${colors.primary}`,
              borderRadius: 12,
              padding: "12px",
              textAlign: "center",
              justifyContent: "center",
              display: "flex",
              marginTop: 16,
              color: colors.white,
              boxShadow: "0 4px 15px rgba(0, 179, 98, 0.3)",
            }}>
            <CustomText size={12} color="primaryDark" style={{ fontWeight: "600", display: "flex", color: colors.white }}>
              🎉 وفرت {<Price price={savedAmount.toFixed(2)} />} في هذا الطلب!
            </CustomText>
          </div>
        )}

        {/* معلومات الشحن */}
        <Divider style={{ margin: "20px 0" }} />
        {/* <div style={{ background: colors.grayLighter, borderRadius: 12, padding: 16 }}>
                    <CustomText size={16} color="black" style={{ fontWeight: '600', display: 'block', marginBottom: 8 }}>
                        🚚 {selectedShipping.name}
                    </CustomText>
                    <CustomText size={11} color="gray">
                        {selectedShipping.duration} • {selectedShipping.description}
                    </CustomText>
                </div> */}

        {/* ميزات إضافية */}
        <div
          style={{
            background: colors.grayLighter,
            borderRadius: 12,
            padding: 16,
            marginTop: 16,
            textAlign: "center",
          }}>
          <Space direction="vertical" size="small" style={{ width: "100%" }}>
            <SafetyCertificateOutlined style={{ fill: colors.primary, fontSize: textSizes[20], color: colors.primary, width: "4rem" }} />
            <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
              {trans("cartFile:securePurchase")}
            </CustomText>
            <CustomText size={11} color="gray">
              {trans("cartFile:warrantyAndSupport")}
            </CustomText>
          </Space>
        </div>
      </div>

      {partErrors.length > 0 && (
        <Alert
          type="error"
          showIcon
          message="لا يمكن إكمال الطلب"
          description={<CustomText style={{ fontSize: "1.5rem", display: "flex" }}>{"بعض المنتجات الكمية المطلوبة لها غير متوفرة. رجاءً عدّل الكميات من السلة."}</CustomText>}
          style={{
            marginTop: 16,
            background: colors.grayLighter,
            border: "none",
            borderRadius: 8,
          }}
        />
      )}
    </Card>
  );
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(resOrderID)
      .then(() => message.success("تم نسخ رقم الطلب!"))
      .catch(() => message.error("فشل النسخ، حاول مرة أخرى."));
  };
  const SuccessModal = () => (
    <Modal
      open={showFinalPopup}
      onCancel={() => setShowFinalPopup(false)}
      footer={null}
      maskClosable={false} // منع الإغلاق بالنقر خارج المودل
      closable={false} // إزالة زر الإغلاق
      keyboard={false}
      centered
      width={500}
      style={{ borderRadius: 20 }}
      bodyStyle={{ padding: 0 }}>
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 10px",
          }}>
          <img src="/assets/images/finalized.svg" alt="" />
        </div>

        <CustomText size={24} color="black" style={{ fontWeight: "700", display: "block", marginBottom: 8 }}>
          {trans("new:thank_to_choose")} 🎉
        </CustomText>
        <CustomText size={30} className={"text-primary"} color={colors.primary} style={{ fontWeight: "700", display: "block", marginBottom: 8 }}>
          {trans("new:HJ_cars")}
        </CustomText>
        {resOrderID ? (
          <>
            <div
              style={{
                padding: "30px 20px",
                textAlign: "center",
                background: "linear-gradient(135deg, #f0f4ff, #d9e4ff)",
                borderRadius: "20px 20px 0 0",
              }}>
              <CustomText size={20} style={{ fontWeight: "700", display: "block", marginBottom: 8 }}>
                {trans("info:order-number")}
              </CustomText>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  backgroundColor: "#fff",
                  padding: "15px 25px",
                  borderRadius: 12,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  fontSize: 20,
                  fontWeight: 600,
                  color: "#0d47a1",
                }}>
                <CustomText size={24} copyable={{ text: resOrderID, icon: <CopyOutlined style={{ fontSize: textSizes[18], width: "3rem" }} /> }}>
                  {resOrderID}
                </CustomText>
              </div>
            </div>

            <CustomText size={20} color="gray" style={{ display: "block", marginBottom: 32, lineHeight: 1.6 }}>
              تم إرسال تفاصيل الطلب إلى حسابك الإلكتروني .
            </CustomText>
          </>
        ) : (
          showFinalPopupMessage && (
            <Alert
              message={
                <Space>
                  <CustomText style={{ fontSize: "2rem", display: "flex" }}>{showFinalPopupMessage}</CustomText>
                </Space>
              }
              type="error"
              showIcon={true}
              style={{
                // marginTop: 16,
                // background: colors.grayLighter,
                // border: 'none',
                display: "block",
                fontSize: "2rem",
                marginBottom: 32,
                lineHeight: 1.6,
                // borderRadius: 8
              }}
            />
          )
        )}

        <Space size="middle">
          <Button
            size="large"
            style={{
              borderRadius: 12,
              height: 45,
              padding: "0 24px",
              border: `2px solid ${colors.grayLight}`,
              fontWeight: "600",
            }}
            onClick={() => {
              if (location.pathname) history.push("/");
            }}>
            {trans("cartFile:Continue_browsing")}
          </Button>
          <Button
            type="primary"
            size="large"
            style={{
              borderRadius: 12,
              height: 45,
              padding: "0 24px",
              background: colors.primaryGradient,
              border: "none",
              fontWeight: "600",
            }}
            onClick={async () => {
              if (dataFinalPopup && dataFinalPopup?.OrderId) history.push("/user/myOrders");
              else {
                // history.go(0); // React Router reload
                window.location.href = window.location.origin + window.location.pathname;
              }
            }}>
            {dataFinalPopup && dataFinalPopup?.OrderId ? trans("new:order_tracking") : trans("new:Create_New")}
          </Button>
        </Space>
      </div>
    </Modal>
  );

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const fullHeight = window.innerHeight * 0.99; // ارتفاع عند الفتح
  const headerHeight = 60; // ارتفاع الهيدر عند الإخفاء

  // تعطيل التمرير في الصفحة الخلفية عند فتح الـ Drawer
  useEffect(() => {
    if (drawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [drawerOpen]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);

  async function SendAllPaymentStatus_Service_Spare(OrderGUID, paymentMethodCallback, paymentStatus) {
    console.log("StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", paymentMethodCallback);
    console.log("StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", paymentStatus);
    console.log("StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", OrderGUID);

    if (paymentMethodCallback == "myFatoorah" || paymentMethodCallback == "paytabs" || paymentMethodCallback == "tabby" || paymentMethodCallback == "sadad") {
    } else if (paymentMethodCallback == "tamara" && paymentStatus == "approved") {
      setShowFinalPopup(true);
      clearCart();
    } else if (paymentMethodCallback == "tamara" && paymentStatus == "canceled") {
      setShowFinalPopup(true);
      setShowFinalPopupMessage("عملية الدفع ملغاة");
    } else if (paymentMethodCallback == "tamara" && paymentStatus) {
      setShowFinalPopup(true);
      setShowFinalPopupMessage(`${paymentStatus}`);
    } else {
      // setIsSendeng(false);
      toast.error(trans("error:unknown_failure"));

      // return;
    }
    if (OrderGUID) {
      try {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = {
          paytype: paymentMethodCallback,
          OrderGUID: OrderGUID,
        };

        await axios
          .request({
            baseURL: config.controllURL,
            url: "api/Payment/SendAllPaymentStatus_Service_Spare",
            headers: myHeaders,
            data: raw,
            method: "POST",
            responseType: "json",
          })
          .then(async (response) => {
            console.log("PaymentMyfatoorahStatusFully respons:", response);
            if (response.data) {
              var data = response.data;
              if (response.data.length > 0) {
                data = response.data.filter((p) => p.Status == "success")[0];
              }

              console.log("PaymentMyfatoorahStatusFully data:", data);
              if (data.Status == "success") {
                setShowFinalPopup(true);
                setDataFinalPopup(data);
                if (data.OrderId) setResOrderID(data.OrderId);
              } else {
                if (paymentMethodCallback == "tabby" && data?.ResponseText == "EXPIRED") {
                  setShowFinalPopup(true);
                  setShowFinalPopupMessage("عملية الدفع ملغاة");
                }
              }
            }
          })
          .catch(async (error) => {
            console.log("error PaymentMyfatoorahStatusFully:", error);
          })
          .finally(() => {});
      } catch (error) {
        console.log("error", error);
      }
    }
  }

  useEffect(() => {
    if (showFinalPopup == true && resOrderID) {
      clearCart();
    }
  }, [showFinalPopup, resOrderID]);

  const clearCart = async () => {
    //set items ids to remove
    const itemIds = items.map((item) => item.id);
    await removePulkcartItems(itemIds);
    getCartList();
  };
  //---------------------
  const handleSubmit = async () => {
    // 🔴 تحقق من المخزون قبل كل شيء
    // const errors = await handleCheckpartsCount(items);
    // if (errors.length > 0) {
    //   message.error("لا يمكن إكمال الطلب، توجد منتجات غير متوفرة");
    //   return;
    // }

    const deliveryTypeValue = form.getFieldValue("deliveryType");
    const selectedSiteId = form.getFieldValue("develviryBranch");

    const res = await handleCheckpartsCountSingleSite(items, deliveryTypeValue === 1 ? selectedSiteId : null);

    if (!res.ok) {
      message.error({
        content: (
          <div
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            لا يمكن إكمال الطلب، يجب توفر الكميات في فرع واحد
          </div>
        ),
        duration: 3,
      });
      return;
    }

    const currentValues = form.getFieldsValue(true);
    console.log("Current values:", currentValues);

    const cleanData = JSON.parse(getData(User_Data_Key, true));
    //// console.log("handlePayment:", cleanData);
    const user_id = cleanData.id.toString().split("_")[1];
    console.log("Current user_id:", user_id);
    if (!user_id) {
      return;
    }
    if (!items || items.length <= 0) {
      message.error("لايوجد عناصر قم بالرجوع الى السلة");
      history.push({
        pathname: `/parts/cart`,
        search: "",
      });
      return;
    }

    if (!isLoadingSendOrder && items && items.length > 0) {
      console.log("deliveryType value:", form.getFieldValue("deliveryType"));
      // هذا سيتحقق من كل الحقول المرتبطة بالـ Form الحالي
      const values = await form.validateFields();

      // إذا نجح الفالديشن، يصل إلى هنا
      console.log("Form values are valid:", values);

      setLoadingSendOrder(true);

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const { ipv4 } = await getUserIpAddress();

      const listofProducts = items.map((item) => ({
        id: item?.id,
        quantity: item?.quantity,
        price: item?.price,
      }));

      var paymentTypeValue = form.getFieldValue("paymentType");
      var develviryCityValue = form.getFieldValue("develviryCity");
      var develviryBranchValue = form.getFieldValue("develviryBranch");
      var addressValue = form.getFieldValue("address");
      var raw = {
        URL: `${window.location.origin}/${lang}/parts/checkout/`,
        Lang: lang,
        Product: listofProducts,
        UserID: user_id,
        DelivaryAddress: addressValue,
        customerDetails: {
          IP: ipv4,
        },
        DataAmount: {
          FinalTotal: total,
          AmountShipping: shippingCost,
          SubAmountTotal: subtotal,
          TotalTaxAmount: tax,
          TotalDiscount: discount,
          MiniDownPayment: totalItems,
        },
        PaymentAmount: total,
        TypePaymnet: {
          PaymnetTypeID: "Cash", //Credit - Cash
          MethodPayment: paymentTypeValue,
        },
        DeliveryType: {
          ByBranch: deliveryTypeValue == 1 ? true : false,
          ByLocation: deliveryTypeValue == 0 ? true : false,
        },
        DeliveryData: {
          InfoBranch: develviryBranchValue,
          InfoLocation: develviryCityValue,
        },

        RefrancePayment: null,
        SpareSalesOrderGUID: null,
      };
      console.log("Payment", raw);

      axios
        .request({
          url: config.controllURL + "api/Payment/SparePartsPayment",
          headers: myHeaders,
          data: raw,
          method: "POST",
          responseType: "json",
        })
        .then(function (response) {
          var responseData = null;
          if (response && response?.data && response?.data?.length > 0) {
            var dataRow = response?.data?.find((a) => a.OrderId != null);
            if (dataRow && dataRow.length > 0) {
              responseData = dataRow[0];
            } else {
              responseData = response?.data[0];
            }
          }

          var invoiceID = responseData?.SadadNumber;
          if (invoiceID) setSadadInfo(invoiceID);
          const paymentUrl = [responseData?.URL_Payment, responseData?.url_payment, responseData?.URL_Paytabs, responseData?.url_Paytabs].find(Boolean);
          if (paymentUrl) {
            window.location.href = paymentUrl;
          } else if (responseData?.MessageError && responseData?.MessageError == "Duplicate Request") {
            window.location.href = `${window.location.origin}/${lang}/parts/cart/`;
          } else if (responseData?.OrderId && responseData?.ResponsMessage == "Paid") {
            setShowFinalPopupMessage(trans("new:paymentAlreadyMade"));
            setShowFinalPopup(true);
            setDataFinalPopup(responseData);
          } else if (responseData?.Message || responseData?.MessageError) {
            setShowFinalPopupMessage(responseData?.Message ?? responseData?.MessageError);
            setShowFinalPopup(true);
            setDataFinalPopup(responseData);
          } else {
            toast.error(trans("error:unknown_failure"));
          }

          setLoadingSendOrder(false);
        })
        .then((response2) => {
          //// console.log('response2', response2);

          setLoadingSendOrder(false);
        })
        .catch((error) => {
          //// console.log('error', error.messages)

          // alert(error.messages)

          setLoadingSendOrder(false);
        });
    }
  };
  // to get info of current ipv4
  const getUserIpAddress = async () => {
    let currentIpv4Info = {};
    try {
      const response = await axios.get("https://geolocation-db.com/json/");
      if (response.status === 200) {
        const { IPv4, country_code, country_name } = response.data;
        currentIpv4Info.ipv4 = IPv4;
        currentIpv4Info.countryCode = country_code;
        currentIpv4Info.countryName = country_name;
      }
    } catch (error) {
      // toast.error(trans("extra:not_connection"))
      //// console.log(error);
    }
    return currentIpv4Info;
  };

  useEffect(() => {
    setFormReady(true);
  }, []);

  // قائمة بالدول مع الأعلام ومفتاح الدولة
  const countryList = [
    { code: "+966", name: "السعودية", flag: "🇸🇦" },
    { code: "+971", name: "الإمارات", flag: "🇦🇪" },
    { code: "+20", name: "مصر", flag: "🇪🇬" },
    { code: "+1", name: "USA", flag: "🇺🇸" },
  ];

  const prefixSelector = (
    <Form.Item name="phoneNumberCode" initialValue="+966" style={{ width: 100, fontSize: textSizes[30], height: "100%" }}>
      <Select
        style={{ width: 100, fontSize: textSizes[30], height: 40 }}
        options={countryList.map((c) => ({
          label: `${c.name} (${c.code})`,
          value: c.code,
        }))}
        suffixIcon={null}
      />
    </Form.Item>
  );
  return formReady ? (
    <div
      style={{
        background: `linear-gradient(135deg, ${colors.grayLighter} 0 %, ${colors.white} 50 %, ${colors.grayLighter} 100 %)`,
        minHeight: "100vh",
        padding: "20px 0",
        marginTop: isMobile ? 40 : 0,
        marginBottom: isMobile ? 80 : 40,
      }}>
      <div
        style={{
          width: "100%",
          maxWidth: "clamp(1400px, 92vw, 2200px)",
          margin: "0 auto",
          padding: "0 24px",
        }}>
        <Breadcrumb
          className={" "}
          links={[
            {
              name: trans("eparts:EpartTitel"),
              to: "/parts",
            },
            {
              name: trans("cartFile:sparePartsCart"),
              to: `/parts/cart`,
            },
            {
              className: "text-primary",
              name: trans("new:complete_order"),
            },
          ]}
        />
        {/* الهيدر المميز */}
        <div
          style={{
            background: colors.white,
            padding: "30px 40px",
            borderRadius: 24,
            marginBottom: 30,
            border: `1px solid ${colors.grayLight} `,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}>
          {/* خلفية زخرفية */}
          <div
            style={{
              position: "absolute",
              top: -50,
              right: -50,
              width: 200,
              height: 200,
              background: colors.primaryGradient,
              borderRadius: "50%",
              opacity: 0.05,
            }}></div>
          <div
            style={{
              position: "absolute",
              bottom: -30,
              left: -30,
              width: 150,
              height: 150,
              background: colors.accent,
              borderRadius: "50%",
              opacity: 0.05,
            }}></div>

          <CustomText
            size={40}
            style={{
              display: "block",
              marginBottom: 8,
              fontWeight: "800",
              background: colors.primaryGradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}>
            🚀 {trans("new:complete_order")}
          </CustomText>
          <CustomText
            size={16}
            color="gray"
            style={{
              display: "block",
              maxWidth: 400,
              margin: "0 auto",
            }}>
            {trans("cartFile:completePurchaseFast")}
          </CustomText>

          {/* خطوات الطلب */}
          <Steps
            current={stepNum}
            style={{
              marginTop: 32,
              maxWidth: 600,
              margin: "32px auto 0",
              padding: "0 20px",
            }}
            items={[
              {
                title: trans("cartFile:deliveryInfo"),
                description: " ",
                backgroundColor: "red",
              },
              {
                title: trans("new:payment_options"),
                description: " ",
              },
              {
                title: trans("cartFile:confirm"),
                description: " ",
              },
            ]}
          />
        </div>
        <ConfigProvider
          theme={{
            components: {
              Form: {
                itemMarginBottom: 16,
                labelColor: colors.black,
                labelFontSize: 14,
                // تنسيقات رسائل الخطأ
                errorItemBg: "#fff2f0",
                errorItemColor: "#ff4d4f",
                errorItemBorderColor: "#ffccc7",
                errorItemFontSize: 10,
                errorsize: 10,
                colorError: colors.danger,
                fontSize: 14,
              },
            },
          }}>
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              deliveryType: 1, // القيمة الافتراضية هنا
              paymentType: null, // القيمة الافتراضية هنا
              name: "",
              phoneNumber: "",
              develviryCity: "",
              address: "",
              develviryBranch: "",
            }}>
            <Row gutter={[30, 30]}>
              {/* المحتوى الرئيسي */}
              <Col xs={24} xl={16}>
                <Space direction="vertical" style={{ width: "100%" }} size={24}>
                  {/* طريقة الشحن */}
                  {stepNum === 0 && (
                    <Card
                      style={{
                        borderRadius: 20,
                        border: "none",
                        background: colors.white,
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                        overflow: "hidden",
                      }}>
                      {/* عنوان الكارد */}
                      <div
                        style={{
                          padding: "16px 24px",
                          color: colors.white,
                          background: colors.grayLighter,
                          borderRadius: 12,
                        }}>
                        <Space>
                          <TruckOutlined style={{ fontSize: textSizes[18], width: "3rem" }} />
                          <CustomText size={18} style={{ fontWeight: "600" }}>
                            {trans("extra:choose_receive_way")}
                          </CustomText>
                        </Space>
                      </div>

                      {/* التبويبات */}
                      <div style={{ padding: 15 }}>
                        {/* Premium Custom Tabs */}
                        <div
                          style={{
                            display: "flex",
                            background: "rgba(0,0,0,0.04)",
                            borderRadius: 20,
                            position: "relative",
                            marginBottom: 32,
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            margin: "0 auto",
                            width: "100%",
                            maxWidth: "400px",
                            border: `1px solid ${colors.grayLight}`,
                          }}>
                          <Form.Item
                            name="deliveryType"
                            rules={rules_schema_1.deliveryType}
                            style={{
                              width: "100%",
                              margin: 0,
                            }}>
                            <Radio.Group
                              optionType="button"
                              buttonStyle="solid"
                              size="large"
                              onChange={(e) => {
                                console.log("Selected deliveryType:", e.target.value);
                                setTimeout(() => {
                                  if (e.target.value === 0) {
                                    form.setFieldValue("develviryBranch", "");
                                    setValueBranch("");
                                  } else {
                                    form.setFieldValue("develviryCity", "");
                                    form.setFieldValue("address", "");
                                    setValueCitie("");
                                  }
                                }, 0);
                              }}
                              style={{
                                width: "100%",
                                display: "flex",
                              }}>
                              {/* <Radio.Button
                                value={0}
                                style={{
                                  flex: 1,
                                  height: "60px",
                                  background: deliveryType == 0 ? "linear-gradient(135deg, #00b362, #00d4aa)" : "linear-gradient(135deg, #ffffff, #f8f8f8)",
                                  border: deliveryType == 0 ? `2px solid ${colors.primary}` : `2px solid ${colors.grayLight}`,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px",
                                  padding: "12px 8px",
                                  transition: "all 0.3s ease",
                                  boxShadow: deliveryType == 0 ? "0 4px 15px rgba(0, 179, 98, 0.3)" : "0 2px 8px rgba(0,0,0,0.05)",
                                  // ✅ إزالة التنسيق الافتراضي
                                  position: "relative",
                                  "&::before": {
                                    display: "none !important",
                                  },
                                }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "2px",
                                  }}>
                                  <HomeOutlined
                                    style={{
                                      fontSize: textSizes[24],
                                      width: "3rem",
                                      color: deliveryType == 0 ? colors.white : colors.grayDark,
                                      margin: 0,
                                    }}
                                  />
                                  <span
                                    style={{
                                      color: deliveryType == 0 ? colors.white : colors.black,
                                      fontSize: textSizes[14],
                                      fontWeight: "600",
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                    }}>
                                    {trans("new:delivery")}
                                  </span>
                                </div>
                              </Radio.Button> */}

                              <Radio.Button
                                value={1}
                                style={{
                                  flex: 1,
                                  height: "60px",
                                  background: deliveryType == 1 ? "linear-gradient(135deg, #00b362, #00d4aa)" : "linear-gradient(135deg, #ffffff, #f8f8f8)",
                                  border: deliveryType == 1 ? `2px solid ${colors.primary}` : `2px solid ${colors.grayLight}`,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px",
                                  padding: "12px 8px",
                                  transition: "all 0.3s ease",
                                  boxShadow: deliveryType == 1 ? "0 4px 15px rgba(0, 179, 98, 0.3)" : "0 2px 8px rgba(0,0,0,0.05)",
                                  // ✅ إزالة التنسيق الافتراضي
                                  position: "relative",
                                  "&::before": {
                                    display: "none !important",
                                  },
                                }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "2px",
                                  }}>
                                  <EnvironmentOutlined
                                    style={{
                                      fontSize: textSizes[24],
                                      width: "3rem",
                                      color: deliveryType == 1 ? colors.white : colors.grayDark,
                                      margin: 0,
                                    }}
                                  />
                                  <span
                                    style={{
                                      color: deliveryType == 1 ? colors.white : colors.black,
                                      fontSize: textSizes[14],
                                      fontWeight: "600",
                                      textAlign: "center",
                                      lineHeight: 1.2,
                                    }}>
                                    {trans("new:branch")}
                                  </span>
                                </div>
                              </Radio.Button>
                            </Radio.Group>
                          </Form.Item>
                        </div>
                        {/* ======================================= */}
                        {/*                التوصيل                  */}
                        {/* ======================================= */}
                        {deliveryType == 0 && (
                          <Space direction="vertical" style={{ width: "100%", marginTop: "2rem" }} size="large">
                            <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item name="name" label={trans("form:name")} rules={rules_schema_1.name}>
                                  <Input size="large" placeholder={trans("form:name")} style={{ borderRadius: 8, fontSize: textSizes[25] }} />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item name="phoneNumber" label={trans("form:phone")} rules={rules_schema_1.phoneNumber}>
                                  <Space.Compact
                                    block
                                    //set ltr all ways for phone number
                                    style={{ direction: "ltr", marginBottom: "0px" }}>
                                    {prefixSelector}
                                    <Form.Item
                                      name="phoneNumber"
                                      rules={rules_schema_1.phoneNumber}
                                      //set full width 100% for input inside space.compact
                                      style={{ width: "100%" }}>
                                      <Input
                                        size="large"
                                        placeholder="5XXXXXXXX"
                                        style={{
                                          fontSize: textSizes[25],
                                        }}
                                      />
                                    </Form.Item>
                                  </Space.Compact>
                                </Form.Item>
                              </Col>

                              {/* اختيار المدينة */}
                              <Col xs={24} md={24}>
                                <Form.Item name="develviryCity" label={trans("new:city")} rules={rules_schema_1.develviryCity}>
                                  <Select
                                    placeholder={trans("new:city")}
                                    className="text-30"
                                    classNames={"text-30"}
                                    size="large"
                                    style={{ borderRadius: 8, fontSize: textSizes[30], width: "100%" }}
                                    suffixIcon={null}
                                    options={[...cities]}
                                    onSelect={handelValueCitie}
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={24}>
                                <Form.Item name="address" label={trans("new:address")} rules={rules_schema_1.address}>
                                  {/* كتابة العنوان */}
                                  <Input.TextArea rows={4} placeholder={trans("new:address")} style={{ borderRadius: 12 }} />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Space>
                        )}

                        {/* ======================================= */}
                        {/*            الاستلام من الفرع            */}
                        {/* ======================================= */}
                        {deliveryType == 1 && (
                          <Space direction="vertical" style={{ width: "100%", marginTop: "2rem" }} size="large">
                            <Form.Item name="develviryBranch" label={trans("cartFile:branch")} rules={rules_schema_1.develviryBranch}>
                              <Select
                                placeholder={trans("cartFile:branch")}
                                size="large"
                                style={{ width: "100%", borderRadius: 8, fontSize: textSizes[20] }}
                                suffixIcon={null}
                                options={[
                                  ...Branches.map((A) => {
                                    return { value: A.SiteID, label: A[`${trans("model:description")}`] };
                                  }),
                                ]}
                                onSelect={handelValueBranch}
                              />
                            </Form.Item>

                            <BranchesInfo values={branchesDetails} />
                          </Space>
                        )}
                      </div>
                    </Card>
                  )}

                  {/* طريقة الدفع */}
                  {stepNum === 1 && (
                    <Card
                      style={{
                        borderRadius: 20,
                        border: "none",
                        background: colors.white,
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                        overflow: "hidden",
                      }}>
                      {/* شريط العنوان */}
                      <div
                        style={{
                          padding: "16px 24px",
                          color: colors.white,
                          background: colors.grayLighter,
                          borderRadius: 12,
                        }}>
                        <Space>
                          <CreditCardOutlined style={{ fontSize: textSizes[18], width: "3rem" }} />
                          <CustomText size={18} style={{ fontWeight: "600" }}>
                            {trans("new:pay_1_method")}
                          </CustomText>
                        </Space>
                      </div>

                      <div style={{ padding: 24 }}>
                        <Form.Item
                          name="paymentType"
                          rules={rules_schema_2.paymentType}
                          style={{
                            width: "100%",
                            margin: 0,
                          }}>
                          <Radio.Group
                            // value={paymentType}
                            // onChange={(e) => form.setFieldValue("paymentType",e.target.value)}
                            style={{ width: "100%" }}>
                            <Space direction="vertical" style={{ width: "100%" }} size="middle">
                              {platformTypes.includes("payTabs") && (
                                <Radio value="payTabs" style={{ width: "100%" }}>
                                  <Card
                                    size="small"
                                    hoverable
                                    onClick={() => form.setFieldValue("paymentType", "payTabs")}
                                    style={{
                                      width: "100%",
                                      border: paymentType === "payTabs" ? `2px solid ${colors.primary} ` : `1px solid ${colors.grayLight} `,
                                      borderRadius: 12,
                                      background: paymentType === "payTabs" ? colors.primary + "08" : colors.white,
                                      boxShadow: paymentType === "payTabs" ? "0 4px 12px rgba(0, 179, 98, 0.1)" : "none",
                                      cursor: "pointer",
                                    }}
                                    bodyStyle={{ padding: 16 }}>
                                    <Row justify="space-between" align="middle">
                                      <div>
                                        <CustomText size={16} color="black" style={{ fontWeight: "600", display: "block" }}>
                                          {trans("new:online_all")}
                                        </CustomText>
                                        <div className="flex flex-row items-center mx-10">
                                          <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt="master" />
                                          <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt="visa" />
                                          <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt="mada" />
                                        </div>
                                      </div>
                                    </Row>
                                  </Card>
                                </Radio>
                              )}
                              {platformTypes.includes("myfatoorah") && (
                                <Radio value="myfatoorah" style={{ width: "100%" }}>
                                  <Card
                                    size="small"
                                    hoverable
                                    onClick={() => form.setFieldValue("paymentType", "myfatoorah")}
                                    style={{
                                      width: "100%",
                                      border: paymentType === "myfatoorah" ? `2px solid ${colors.primary} ` : `1px solid ${colors.grayLight} `,
                                      borderRadius: 12,
                                      background: paymentType === "myfatoorah" ? colors.primary + "08" : colors.white,
                                      boxShadow: paymentType === "myfatoorah" ? "0 4px 12px rgba(0, 179, 98, 0.1)" : "none",
                                      cursor: "pointer",
                                    }}
                                    bodyStyle={{ padding: 16 }}>
                                    <Row justify="space-between" align="middle">
                                      <div>
                                        <CustomText size={16} color="black" style={{ fontWeight: "600", display: "block" }}>
                                          {trans("new:online_all")}
                                        </CustomText>
                                        <div className="flex flex-row items-center mx-10">
                                          <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt="master" />
                                          <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt="visa" />
                                          <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt="mada" />
                                        </div>
                                      </div>
                                    </Row>
                                  </Card>
                                </Radio>
                              )}

                              {platformTypes.includes("tamara") && (
                                <Radio value="tamara" style={{ width: "100%" }}>
                                  <Card
                                    size="small"
                                    hoverable
                                    onClick={() => form.setFieldValue("paymentType", "tamara")}
                                    style={{
                                      width: "100%",
                                      border: paymentType === "tamara" ? `2px solid ${colors.primary} ` : `1px solid ${colors.grayLight} `,
                                      borderRadius: 12,
                                      background: paymentType === "tamara" ? colors.primary + "08" : colors.white,
                                      boxShadow: paymentType === "tamara" ? "0 4px 12px rgba(0, 179, 98, 0.1)" : "none",
                                      cursor: "pointer",
                                    }}
                                    bodyStyle={{ padding: 16 }}>
                                    <Row justify="space-between" align="middle">
                                      <div>
                                        <CustomText size={16} color="black" style={{ fontWeight: "600", display: "block" }}>
                                          {trans("new:byTamara")}
                                        </CustomText>
                                        <div className="flex flex-row cart-payment-icon">
                                          <img className="cart-payment-icon object-contain" src={lang == "ar" ? "/assets/icons/AR-tamara.svg" : "/assets/icons/En-tamara.svg"} alt="tamara" />
                                        </div>
                                        <CustomText size={12} color="gray">
                                          {trans("new:byTamara3")}
                                        </CustomText>
                                        <CustomText size={12} color="gray">
                                          {trans("new:byTamara4")}
                                        </CustomText>
                                      </div>
                                    </Row>
                                  </Card>
                                </Radio>
                              )}

                              {platformTypes.includes("tabby") && (
                                <Radio value="tabby" style={{ width: "100%" }}>
                                  <Card
                                    size="small"
                                    hoverable
                                    onClick={() => form.setFieldValue("paymentType", "tabby")}
                                    style={{
                                      width: "100%",
                                      border: paymentType === "tabby" ? `2px solid ${colors.primary} ` : `1px solid ${colors.grayLight} `,
                                      borderRadius: 12,
                                      background: paymentType === "tabby" ? colors.primary + "08" : colors.white,
                                      boxShadow: paymentType === "tabby" ? "0 4px 12px rgba(0, 179, 98, 0.1)" : "none",
                                      cursor: "pointer",
                                    }}
                                    bodyStyle={{ padding: 16 }}>
                                    <Row justify="space-between" align="middle">
                                      <div className="flex flex-row flex-col ">
                                        <CustomText size={16} color="black" style={{ fontWeight: "600" }}>
                                          {lang == "ar" ? "قسّمها على 4 دفعات ,بدون فوائد أو رسوم" : "Pay in 4. No interest, no fees"}
                                        </CustomText>
                                        <img className="cart-payment-icon object-contain" src="/assets/icons/tabby.png" alt="tabby" />
                                      </div>
                                    </Row>
                                    {MessageError && (
                                      <div className="language-en nice-border text-bold flex border-error flex-col nice-gap-1rem p-10 my-10 text-error text-20" style={{ backgroundColor: "#ffe6e3" }}>
                                        {MessageError}
                                      </div>
                                    )}
                                  </Card>
                                </Radio>
                              )}

                              {platformTypes.includes("sadad") && (
                                <Radio value="sadad" style={{ width: "100%" }}>
                                  <Card
                                    size="small"
                                    hoverable
                                    onClick={() => form.setFieldValue("paymentType", "sadad")}
                                    style={{
                                      width: "100%",
                                      border: paymentType === "sadad" ? `2px solid ${colors.primary} ` : `1px solid ${colors.grayLight} `,
                                      borderRadius: 12,
                                      background: paymentType === "sadad" ? colors.primary + "08" : colors.white,
                                      boxShadow: paymentType === "sadad" ? "0 4px 12px rgba(0, 179, 98, 0.1)" : "none",
                                      cursor: "pointer",
                                    }}
                                    bodyStyle={{ padding: 16 }}>
                                    <Row align="middle">
                                      <img src="/assets/icons/companies/SADAD-Logo.png" width={60} alt="SADAD" />
                                    </Row>
                                  </Card>
                                </Radio>
                              )}
                            </Space>
                          </Radio.Group>
                        </Form.Item>
                        <Alert
                          message={
                            <Space>
                              {" "}
                              <LockOutlined />{" "}
                              <CustomText size={12} color="gray">
                                {" "}
                                {trans("cartFile:securePurchase")}{" "}
                              </CustomText>{" "}
                            </Space>
                          }
                          type="info"
                          showIcon={false}
                          style={{
                            marginTop: 16,
                            background: colors.grayLighter,
                            border: "none",
                            borderRadius: 8,
                          }}
                        />
                      </div>
                    </Card>
                  )}

                  {stepNum === 2 && <OrderSummary2 />}
                  {/* أزرار التنقل */}
                  <Card
                    style={{
                      borderRadius: 20,
                      border: "none",
                      background: colors.white,
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
                    }}
                    bodyStyle={{ padding: 24 }}>
                    <Row justify="space-between" align="middle">
                      <Col>
                        {stepNum > 0 && (
                          <Button
                            size="large"
                            onClick={async () => handlePrev()}
                            style={{
                              borderRadius: 12,
                              padding: "0 32px",
                              height: 48,
                              fontSize: textSizes[16],
                              border: `2px solid ${colors.grayLight} `,
                              fontWeight: "600",
                            }}>
                            {trans("cartFile:previous")}
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          type="primary"
                          size="large"
                          // disabled={partErrors.length > 0}
                          onClick={async () => handleNext()}
                          style={{
                            borderRadius: 12,
                            padding: "0 32px",
                            height: 48,
                            fontSize: textSizes[16],
                            background: colors.primaryGradient,
                            border: "none",
                            boxShadow: "0 4px 15px rgba(0, 179, 98, 0.3)",
                            fontWeight: "700",
                          }}
                          icon={stepNum === 2 ? <CreditCardOutlined style={{ fontSize: textSizes[18], width: "3rem" }} /> : <RocketOutlined style={{ fontSize: textSizes[18], width: "3rem" }} />}>
                          {stepNum === 2 ? trans("new:Pay_Now") : trans("new:nextStep")}
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                </Space>
              </Col>

              {/* الملخص الجانبي */}
              {/* الملخص الجانبي للشاشات الكبيرة */}
              <Col xs={0} xl={8}>
                <OrderSummary />
              </Col>
            </Row>
          </Form>
        </ConfigProvider>
        <SuccessModal />
      </div>
      {isMobile && (
        <div
          style={{
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            top: drawerOpen ? window.innerHeight - fullHeight : window.innerHeight - headerHeight,
            background: "#fff",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            boxShadow: "0 -4px 20px rgba(0,0,0,0.1)",
            transition: "top 0.3s ease-in-out",
            overflow: "hidden",
            zIndex: 1000,
          }}>
          <div
            style={{
              cursor: "pointer",
              height: headerHeight,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderBottom: "1px solid #eee",
              background: "#fff",
              zIndex: 1001,
            }}
            onClick={toggleDrawer}
            onTouch={toggleDrawer}>
            <div
              style={{
                width: 40,
                height: 5,
                background: "#ccc",
                borderRadius: 2.5,
                marginBottom: 8,
              }}
            />
          </div>

          {
            // drawerOpen &&
            <div style={{ padding: 16, overflowY: "auto", height: fullHeight - headerHeight }}>
              <OrderSummary />
            </div>
          }
        </div>
      )}

      <CheckoutProgressModal open={isLoadingSendOrder} />
    </div>
  ) : null;
};

export default PremiumCheckoutPage;
